import React from 'react';
import noop from 'lodash/noop';
import classNames from 'classnames';
import { Checkbox } from 'antd';
import styles from './index.less';
// eslint-disable-next-line react/display-name
const FilterCell = React.memo(({
  checked,
  className,
  filter,
  onChange,
  isCheckbox,
}) => {
  const { name, enabled } = filter;
  const ruleText = filter.rule_text;
  const classes = classNames(styles.filterCell, className);
  return (
    <div className={classes}>
      <Checkbox
        className={isCheckbox === false && 'checkbox-rounded'}
        checked={checked}
        onChange={onChange}
        disabled={!enabled}
      >
        <span title={ruleText}>
          {name}
        </span>
      </Checkbox>
    </div>
  );
});

FilterCell.defaultProps = {
  className: '',
  checked: false,
  onChange: noop,
  isCheckbox: false,
};

export default FilterCell;
